import { Component, OnInit,EventEmitter, Output, Input,SimpleChanges } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { time } from 'highcharts';
import { animate, style, transition, trigger } from '@angular/animations';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import { DateUtils } from 'src/app/utils/days-utils';
dayjs.extend(utc);
dayjs.extend(timezone);
@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-10%)', opacity: 0 }),
        animate(
          '300ms ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        )
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate(
          '300ms ease-in',
          style({ transform: 'translateY(-10%)', opacity: 0 })
        )
      ]),
    ]),
  ],
})
export class EmployeeListComponent implements OnInit {
  imgSrc: string;
  @Output() closePopup = new EventEmitter<any>();
  @Input() fromCabTripReplay:boolean = false;
  @Input() stopDetail:any
  @Input() tripDetails:any
  @Input() isOffice:any
  otaOtdData:boolean
  employeesList:any
  entry=0;
  noshow=0;
  adhoc=0;
  reason :string;
  isDelayed:boolean;
  timeDelay:any;
  plannedSignIns:any[];
  adhocSignIns:any[];

  tripDelayDetails:any;
      
  
  constructor(private commonService:CommonService, private envService: EnvironmentService) { }

  toggler:any='planned'
  colors = ["#CBDDFB", "#E4F5E9", "#FAE1EA", "#E8C8AF", "#BBE6FF","#FFC6F2","#F4E7C3","#DACFF9","#ACDADA"];

  getDelayMessage(delayDetails: any): string {
    if (!delayDetails) return 'On Time/Early (No Delay)';
    if (delayDetails.DELAY_MINS > 0) return `Delayed by ${delayDetails.DELAY_MINS} min(s)`;
    return 'NA';
  }
  ngOnInit(): void 
  {
    this.commonService.tripMetaData$.subscribe((data) => { 
      if(data['DELAY_METADATA'] && Object.keys(data['DELAY_METADATA'])?.length){
        this.tripDelayDetails = {
          ...data['DELAY_METADATA'],
          TRIP_DELAY_LOGIN_GRACE_SECS: this.commonService.TRIP_DELAY_LOGIN_GRACE_SECS,
          TRIP_DELAY_LOGOUT_GRACE_SECS: this.commonService.TRIP_DELAY_LOGOUT_GRACE_SECS,
          EMPLOYEE_GRACE_TIME_MIN: this.commonService.EMPLOYEE_GRACE_TIME_MIN,
          TRIP_DIRECTION:this.tripDetails.direction
        };
      }
     });
     if(this.tripDetails.actualArrivalTime>this.tripDetails.plannedArrivalTime){
      this.isDelayed=true;
      
    const delayInMinutes = dayjs(this.tripDetails.actualArrivalTime).diff(dayjs(this.tripDetails.plannedArrivalTime), 'minute');
      console.log(delayInMinutes, 'delayInMinutes');
      this.timeDelay = delayInMinutes >= 0 ? delayInMinutes : 0; // Ensure delay is non-negative
            
     }
    this.employeesList = this.tripDetails?.employees;
    this.imgSrc = this.envService.getImgSrc();
    for(let i=0;i<this.stopDetail?.plannedEmployees.length;i++)
    {
      if(this.stopDetail.plannedEmployees[i].empStatus=='NO_SHOW')
      {
        this.noshow++;
      }
      else if(this.stopDetail.plannedEmployees[i].empStatus=='ADHOC')
      {
        this.adhoc++;
        this.entry++;
      } 
      else{
        this.entry++;
      }
      
    }
    for(let i=0;i<this.stopDetail?.unplannedEmployees.length;i++)
      {
        if(this.stopDetail.unplannedEmployees[i].empStatus=='NO_SHOW')
        {
          this.noshow++;
        }
        else if(this.stopDetail.unplannedEmployees[i].empStatus=='ADHOC')
        {
          this.adhoc++;
          this.entry++;
        } 
        else{
          this.entry++;
        }
        
      }
    if(this.otaOtdData){
      this.entry=this.adhoc=this.noshow=0;
      for(let i=0;i<this.employeesList.length;i++)
        {
          if(this.employeesList[i].shuttleEmpSignInType=='NO_SHOW')
          {
            this.noshow++;
          }
          else if(this.employeesList[i].shuttleEmpSignInType=='ADHOC')
          {
            this.adhoc++; 
            this.entry++;
          } 
          else{
            this.entry++;
          }
          
        }
    }
    if(this.fromCabTripReplay){
      this.entry=this.adhoc=this.noshow=0;
      for(let i=0;i<this.employeesList.length;i++)
        {
          if(this.employeesList[i].noShow)
          {
            this.noshow++;
          }
          else if(this.employeesList[i].adhoc)
          {
            this.adhoc++; 
            this.entry++;
          } 
          else{
            this.entry++;
          }
          
        }
    }

    this.plannedSignIns = this.employeesList.filter((emp:any)=>{
      return !emp.adhoc
    })
    this.adhocSignIns = this.employeesList.filter((emp:any)=>{
      return emp.adhoc
    })
  
  }
  isExpanded = false; // Initially collapsed

  toggleExpandCollapse() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.otaOtdData = this.isOffice || this.stopDetail.isOffice
  }
  
  onClosePopup()
  {
    this.closePopup.emit({value:false,data:this.stopDetail});
  }
  toggle(check:any)
  {
    if(check=='planned')
    {
      this.toggler='planned'
    }
    else
    {
      this.toggler='unPlanned'
    }
  }

  getShuttleStatus(status: string): { color: string, name: string } {
    switch (status) {
      case 'NOT_BOARDED_YET':
        return { color: '#6A737D', name: 'Not Boarded Yet' };
      case 'PLANNED':
        return { color: '#0937B2', name: 'Planned' };
      case 'ADHOC':
        return { color: '#E65010', name: 'Ad Hoc' };
      case 'NO_SHOW':
        return { color: '#B00020', name: 'No Show' };
      case 'DIFFERENT_SIGNIN_LOCATION':
        return { color: '#D4900C', name: 'Different Sign In Location' };
      default:
        return { color: '', name: '' };
    }
  }

  getConvertedTimeZoneTime(time){
    if(!!time){
    return DateUtils.formatTimeWithZone(time, this.commonService.timeZone, 'LT');
    }else {
      return "--";
    }
  }

  formatDate(epoch:any){
    return DateUtils.formatEpochToTime(epoch, 'HH:mm');

  }

  calculateFinalDiff(planned:number , actual:number) {
    if(this.tripDetails.direction === 'IN') {
      planned += (this.commonService.TRIP_DELAY_LOGIN_GRACE_SECS*1000)
    }
    else {
      planned += (this.commonService.TRIP_DELAY_LOGOUT_GRACE_SECS*1000)
    }
    
    if(planned === 0 && actual === 0 ){
      return 'gray-text'
    }
    if(planned >= actual){
      return 'green-text'
    }
    if(planned < actual){
      return 'red-text'
    }
    return 'red-text'
  }
  
  calculateStopDifference(plannedStart:string , actualEnd:string){
    const [startHour , startMin] = plannedStart?.trim()?.split(":")?.map(Number)
    const [endHour , endMin] = actualEnd?.trim()?.split(":")?.map(Number)

    if(endHour === 0 && endMin === 0 ){
      return 'gray-text'
    }
    if(endHour < startHour){
      return 'green-text'
    }
    if(endHour === startHour && endMin <= startMin){
      return 'green-text'
    }
    return 'red-text'
    
  }
}
